import './AccountPanelBattle.scss';
import Control from "../../../../1. Core/Control";
import Label from "../../../../1. Core/Controls/Label/Label";
import NP from "../../../../1. Core/NP";
import Delegate from "../../../../1. Core/Delegate";
import UserInfo, {IUserInfo} from "../../../../1. Core/UserInfo";
import {escapeHTML} from "../../../../1. Core/util-fun";



export default class AccountPanelBattle extends Control {
	private _mainNode: HTMLElement;
	private _avatarNode: HTMLElement;
	private _aboutNode: HTMLElement;
	private _firstLastNameLbl: Label;
	private EvModeChanged: Delegate;

	constructor(settings?: object)
	{
		super(settings);
		this._render();
	}

	_initFields(settings: object)
	{
		this.EvModeChanged = new Delegate();
		super._initFields(settings);
	}

	_render()
	{
		this.np_render('<div class="account-panel-battle">' +
			 '<div class="account-panel-battle__main-node">' +
			 '<div class="account-panel-battle__avatar"/></div>' +
			 '<div class="account-panel-battle__about-node"></div>' +
			 '</div>');

		this._mainNode = this._root.firstChild as HTMLElement;

		this._avatarNode = this._root.querySelector('.account-panel-battle__avatar');
		this._aboutNode = this._root.querySelector('.account-panel-battle__about-node');

		this._firstLastNameLbl = new Label({
			ParentNode: this._aboutNode,
			Class: 'top-app-bar__title selectable',
			TextWrap: false
		});
		this._firstLastNameLbl.removeClass('label');
	}

	refresh()
	{
		let user = NP.getCurrentUser();

		//this._avatarNode.innerHTML = NP.getUserImage(user);

		this._firstLastNameLbl.setContent(escapeHTML(UserInfo.getViewName({
			FirstName: user.getFirstName(),
			LastName: user.getLastName(),
			Email: user.getEmail()
		} as IUserInfo)));
	}
};